import __request__ from 'routing/request';
interface PageListResponse_DataLakeRetrievalResult {
    readonly total: number;
    readonly pagination: PaginatedList__PaginationInfo;
    readonly defaults: EntityDefaults;
    readonly query: string;
    readonly elements: DataLakeRetrievalResult[];
    readonly attributes: EntityAttribute[];
    readonly sort: string;
    readonly order: 'asc' | 'desc';
}
interface DataLakeRetrievalResult {
    readonly timestamp_to: string;
    readonly restore_indices: DataLakeRetrievalResult__RestoreIndex[];
    readonly retrieved_documents: number;
    readonly index_failures: number;
    readonly retrieved_at: string;
    readonly type: 'ICEBERG' | 'TRINO' | 'ATHENA';
    readonly timestamp_from: string;
    readonly duration: string;
    readonly stream_id: string;
    readonly stream_title: string;
    readonly id: string;
    readonly partially_retrieved: boolean;
    readonly source_name: string;
    readonly username: string;
    readonly status: 'COMPLETE' | 'PARTIAL';
}
interface EntityAttribute {
    readonly filterable: boolean;
    readonly related_property: string;
    readonly related_collection: string;
    readonly hidden: boolean;
    readonly sortable: boolean;
    readonly id: string;
    readonly type: 'STRING' | 'DATE' | 'DOUBLE' | 'INT' | 'LONG' | 'OBJECT_ID' | 'BOOLEAN';
    readonly title: string;
    readonly searchable: boolean;
    readonly filter_options: FilterOption[];
}
interface EntityDefaults {
    readonly sort: Sorting;
}
interface PaginatedList__PaginationInfo {
    readonly per_page: number;
    readonly total: number;
    readonly count: number;
    readonly page: number;
}
interface FilterOption {
    readonly title: string;
    readonly value: string;
}
interface PaginationParameters {
    readonly per_page: number;
    readonly query: string;
    readonly page: number;
    readonly sort_by: string;
    readonly order: string;
}
type stringArray = string[];
interface DataLakeRetrievalResult__RestoreIndex {
    readonly index_set_id: string;
    readonly index_name: string;
}
interface Sorting {
    readonly id: string;
    readonly direction: 'ASC' | 'DESC';
}
/**
 * Returns all data lake retrievals
 */
export function getAllRetrievalResults(paginationparameters?: PaginationParameters, filters?: stringArray): Promise<PageListResponse_DataLakeRetrievalResult> {
    return __request__('GET', '/plugins/org.graylog.plugins.datalake/data_lake/retrievals', paginationparameters, { 'filters': filters }, {
        'Accept': ['application/json']
    });
}
